export default (arr) => arr[Math.floor(Math.random() * arr.length)];
